<ng-container *ngIf="featureTags && !featureTags['sf_enhance_registration_membership']">
<ng-container *ngIf="featureTags && featureTags['sf_creditcard_details']">
    <ng-container *ngIf="featureTags && !featureTags['sf_credit_card_alert']">
        <mat-toolbar-row class="alertbarBg" *ngIf="loggedIn && creditCards?.length == 0">
            <a class="telInfo" fxLayoutAlign="start center">
                <mat-icon>notification_important</mat-icon>
            </a>
            <div class="containerLg containerLgMbl" fxLayoutAlign="center center" #top>
                <span class="alertTxt" style="font-weight: 700;" [ngClass]="{'addGap': shouldAddGap}">No Payment Method
                    on File: Please add a credit
                    card to ensure your delivery.
                    <a class="hand-hover" style="color: white;text-wrap-mode: nowrap;"
                        routerLink="/account/payment/add-credit-card">
                        Add Credit Card
                    </a></span>
            </div>
        </mat-toolbar-row>
    </ng-container>
    <ng-container *ngIf="featureTags && featureTags['sf_credit_card_alert']">
        <ng-container *ngIf="featureTags && !featureTags['ftag_sf_card_expiry']">
            <mat-toolbar-row class="alertbarBg" *ngIf="loggedIn && creditCards?.length == 0 && creditCardsNotFound">
                <a class="telInfo" fxLayoutAlign="start center">
                    <mat-icon>notification_important</mat-icon>
                </a>
                <div class="containerLg containerLgMbl" fxLayoutAlign="center center" #top>
                    <span class="alertTxt" style="font-weight: 700;" [ngClass]="{'addGap': shouldAddGap}">No Payment
                        Method on File: Please add a credit
                        card to ensure your delivery.
                        <a class="hand-hover" style="color: white;text-wrap-mode: nowrap;"
                            routerLink="/account/payment/add-credit-card">
                            Add Credit Card
                        </a></span>

                </div>
            </mat-toolbar-row>
        </ng-container>
        <ng-container *ngIf="!!featureTags && featureTags['ftag_sf_card_expiry']">
            <mat-toolbar-row class="alertbarBg" *ngIf="loggedIn && creditCardsNotFound">
                <a class="telInfo" fxLayoutAlign="start center">
                    <mat-icon>notification_important</mat-icon>
                </a>
                <div class="containerLg containerLgMbl" fxLayoutAlign="center center" #top>
                    <span class="alertTxt" style="font-weight: 700;" [ngClass]="{'addGap': shouldAddGap}">No Payment
                        Method on File: Please add a credit
                        card to ensure your delivery.
                        <a class="hand-hover" style="color: white;text-wrap-mode: nowrap;"
                            routerLink="/account/payment/add-credit-card">
                            Add Credit Card
                        </a></span>

                </div>
            </mat-toolbar-row>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="!!featureTags && featureTags['ftag_sf_card_expiry']">
        <mat-toolbar-row class="alertbarBg" *ngIf="loggedIn && creditCards?.length >= 1 && (ccDeclined || ccExpired)">
            <a class="telInfo" fxLayoutAlign="start center">
                <mat-icon>notification_important</mat-icon>
            </a>
            <div class="containerLg containerLgMbl" fxLayoutAlign="center center" #top>
                <span class="alertTxt" style="font-weight: 700;" [ngClass]="{'addGap': shouldAddGap}">Billing Issue
                    Detected: Please update your payment information to ensure uninterrupted service.
                    <a class="hand-hover" style="color: white;text-wrap-mode: nowrap;" routerLink="/account/payment">
                        Update Payment Details
                    </a></span>

            </div>
        </mat-toolbar-row>
    </ng-container>
</ng-container>
</ng-container>

<ng-container *ngIf="featureTags && featureTags['sf_enhance_registration_membership']">
    <ng-container *ngIf="userDetails && (userDetails['preferred_payment_method'] === 'Credit Card' || userDetails['preferred_payment_method'] === '')">
        <mat-toolbar-row class="alertbarBg" *ngIf="loggedIn && creditCardsNotFound">
            <a class="telInfo" fxLayoutAlign="start center">
                <mat-icon>notification_important</mat-icon>
            </a>
            <div class="containerLg containerLgMbl" fxLayoutAlign="center center" #top>
                <span class="alertTxt" style="font-weight: 700;" [ngClass]="{'addGap': shouldAddGap}">No Payment
                    Method on File: Please add a credit
                    card to ensure your delivery.
                    <a class="hand-hover" style="color: white;text-wrap-mode: nowrap;"
                        routerLink="/account/payment/add-credit-card">
                        Add Credit Card
                    </a></span>
    
            </div>
        </mat-toolbar-row>
        <mat-toolbar-row class="alertbarBg" *ngIf="loggedIn && creditCards?.length >= 1 && (ccDeclined || ccExpired)">
            <a class="telInfo" fxLayoutAlign="start center">
                <mat-icon>notification_important</mat-icon>
            </a>
            <div class="containerLg containerLgMbl" fxLayoutAlign="center center" #top>
                <span class="alertTxt" style="font-weight: 700;" [ngClass]="{'addGap': shouldAddGap}">Billing Issue
                    Detected: Please update your payment information to ensure uninterrupted service.
                    <a class="hand-hover" style="color: white;text-wrap-mode: nowrap;" routerLink="/account/payment">
                        Update Payment Details
                    </a></span>
    
            </div>
        </mat-toolbar-row>
    </ng-container>
</ng-container>